import React from 'react';
import PropTypes from 'prop-types';

// Section components
import Scratchpad from '../Scratchpad';
import MLPModule from '../MLPModule';
import Trustpilot from '../Trustpilot/AsyncTrustpilot';
import TrustPilotEU from '../Trustpilot/TrustPilotEU';
import PropertyTypes from '../PropertyTypes';
import Trending from '../Trending';
import TrendingCorridorDestinations from '../TrendingCorridorDestinations';
import Lyp from '../Lyp';
import { ValueProps } from '../ValueProps';
import Linkpiles, { CarouselLinkpiles } from '../Linkpiles';
import RecentTravelerActivity from '../RecentTravelerActivity';
import VrboRefreshMessage from '../VrboRefreshMessage';
import { Experiment } from '../Experiment';
import ErrorBoundary from '../ErrorBoundary';

import './Content.less';

const CNAME = 'Content';

const Content = ({ sections, showTrustPilot, showTrustPilotEU }) => (
  <main role="main">
    <article className={CNAME}>
      <Experiment name="HA_PTA_HP_StayzOnPlatform">
        {stayzOnPlatformValue => stayzOnPlatformValue !== 0 &&
           (
             <Experiment name={'HA_PTA_HP_VrboRefreshMessaging'}>
               {
                 refreshMessagingValue => refreshMessagingValue === 1
                   ? <VrboRefreshMessage />
                   : <ValueProps />
               }
             </Experiment>
           )
        }
      </Experiment>
      <Experiment name={'HA_PTA_HP_RecentActivityOptimizationV2'}>
        {value => value === 1
          ? <RecentTravelerActivity />
          : <Scratchpad />
        }
      </Experiment>
      <Experiment name="HA_PTA_HP_StayzOnPlatform">
        {value => value !== 0 &&
          <ErrorBoundary>
            <PropertyTypes />
          </ErrorBoundary>
        }
      </Experiment>
      <Experiment name="HA_PTA_HP_CorridorTrendingDestinations">
        {value => value === 1
          ? <TrendingCorridorDestinations />
          : <Trending />
        }
      </Experiment>
      <MLPModule />
      {showTrustPilot && <Trustpilot />}
      {showTrustPilotEU && <TrustPilotEU />}
      <Experiment name="HA_PTA_LANDING_ScaleListYourPropertyV2" earlyReport>
        {value => value !== 0
          ? <Lyp />
          : null
        }
      </Experiment>
      <Experiment name="HA_PTA_HP_StayzOnPlatform">
        {(value, experiment) => experiment && value === 0
          ? <CarouselLinkpiles {...sections.filter(section => section.id === 'hp-linkpile')[0]}/>
          : <Linkpiles />
        }
      </Experiment>
    </article>
  </main>
);

Content.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object)
};

export default Content;
